<template>
  <div>
    <div id="main-content" class="relative flex justify-center w-full pt-12 pb-32 md:items-start xl:pt-32 hero header-height-top-space viewport-gutter">
      <div class="w-full">
        <div class="container w-full">
          <div class="w-full max-w-xl xl:max-w-4xl">
            <h1 class="text-2.5xl leading-tight font-bold pb-5 md:text-4xl xl:pb-7 text-white font-lufthansa-head">
              {{ tr('pages.sales.landing.hero.title') }}
            </h1>
          </div>
          <div class="md:max-w-xl xl:max-w-3xl text-white">
            <p class="text-lg font-light md:text-xl xl:text-2xl leading-7">
              {{ tr('pages.sales.landing.hero.subtitle') }}
            </p>
          </div>

          <div class="pt-7 xl:pt-14">
            <div class="max-w-75">
              <Button
                id="hero-action-button"
                :href="$i18nTo({ name: 'voucherSaleAmount' })"
                variant="primary"
                full-width
              >
                {{ tr('pages.sales.landing.hero.button') }}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="relative -mt-20 pb-14 viewport-gutter xl:pb-20">
      <div class="container">
        <div class="flex flex-col px-4 py-6 bg-white border border-4y-gray-100 md:flex-row md:py-6 xl:px-10 xl:pb-10 xl:pt-11">
          <div class="flex mb-5 md:w-1/3 md:mb-0 md:mr-6 xl:mr-10">
            <div class="flex-shrink-0 mr-3 -mt-0.5 text-4y-sky-blue">
              <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:aria-hidden="'true'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M8.364 10.182c.602 0 1.09-.489 1.09-1.091V5.455a1.091 1.091 0 00-2.181 0V9.09c0 .602.488 1.09 1.09 1.09z" fill="currentColor"/><path d="M25.455 7.273V9.09a1.818 1.818 0 11-3.637 0V7.273H10.182V9.09a1.818 1.818 0 11-3.637 0V7.273H4.364v18.909c0 .8.654 1.454 1.454 1.454h20.364c.8 0 1.455-.653 1.455-1.453V7.273h-2.182zm.727 18.908l-.004.002H5.822l-.003-.002-.002-13.09h20.366l-.001 13.09z" fill="currentColor"/><path d="M23.636 10.182c.603 0 1.091-.489 1.091-1.091V5.455a1.091 1.091 0 00-2.182 0V9.09c0 .602.489 1.09 1.091 1.09zM13.497 14.546h-2.49v2.548h2.49v-2.549zM17.23 14.546h-2.489v2.548h2.49v-2.549zM20.965 14.546h-2.49v2.548h2.49v-2.549zM9.762 18.369h-2.49v2.549h2.49v-2.55zM13.497 18.369h-2.49v2.549h2.49v-2.55zM17.23 18.369h-2.489v2.549h2.49v-2.55zM24.698 14.546h-2.49v2.548h2.49v-2.549zM24.698 18.369h-2.49v2.549h2.49v-2.55zM9.762 22.186h-2.49v2.55h2.49v-2.55zM13.497 22.186h-2.49v2.55h2.49v-2.55zM17.23 22.186h-2.489v2.55h2.49v-2.55zM20.965 22.186h-2.49v2.55h2.49v-2.55zM18.93 20.933l.782-.783.783.783.508-.508-.783-.783.783-.783-.508-.508-.783.783-.783-.783-.508.508.783.783-.783.783.508.508z" fill="currentColor"/></svg>
            </div>
            <div class="leading-snug">
              <h3 class="pb-1 text-base font-lufthansa-head font-bold md:pb-2 xl:text-2xl text-4y-sky-blue">
                {{ tr('pages.sales.landing.benefit.one.title') }}
              </h3>
              <p class="text-sm leading-snug xl:text-base tracking-wide">
                {{ tr('pages.sales.landing.benefit.one.description') }}
              </p>
            </div>
          </div>
          <div class="flex mb-5 md:w-1/3 md:mb-0 md:mr-6 xl:mr-10">
            <div class="flex-shrink-0 mr-3 -mt-0.5 text-4y-sky-blue">
              <svg width="33" height="32" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:aria-hidden="'true'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M16.667 2.91C9.437 2.91 3.576 8.77 3.576 16c0 7.23 5.86 13.09 13.09 13.09 7.23 0 13.092-5.86 13.092-13.09 0-7.23-5.861-13.09-13.091-13.09zm-8.068 21.5A11.578 11.578 0 015.013 16c0-.9.103-1.783.3-2.638l.81.82.726.727.364.364.727.727-1.09 1.09v1.092l1.75 1.765v4.463zm17.148-10.592h-2.535l-.727-.727h-2.91l-2.153 2.182v1.868L23.161 24l-.002 1.682a11.571 11.571 0 01-6.492 1.972c-2.37 0-4.63-.703-6.546-2.009V24l3.637-4.364v-1.454l-2.546-2.546H9.03l-1.454-1.454V13.09l1.454-1.455h1.455l3.273-3.272V4.71c.939-.24 1.914-.365 2.909-.365 2.588 0 5.046.838 7.067 2.386l-.526.51h-1.827v2.576h-1.809V12h2.182l1.454-1.455h1.455l1.303 1.314-.219 1.96zm1.076.702l.338-.338.852-.857c.203.867.308 1.763.308 2.675v.028l-1.498-1.508z" fill="currentColor"/></svg>
            </div>
            <div class="leading-snug">
              <h3 class="pb-1 text-base font-lufthansa-head font-bold md:pb-2 xl:text-2xl text-4y-sky-blue">
                {{ tr('pages.sales.landing.benefit.two.title') }}
              </h3>
              <p class="text-sm leading-snug xl:text-base tracking-wide">
                {{ tr('pages.sales.landing.benefit.two.description') }}
              </p>
            </div>
          </div>
          <div class="flex md:w-1/3">
            <div class="flex-shrink-0 mr-3 -mt-0.5 text-4y-sky-blue">
              <svg width="33" height="32" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:aria-hidden="'true'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M11.934 13.082h.001l.806-.8c.504-.402 1.005-.297 1.005-.297.963.157 1.08 1.045 1.08 1.045.117 1.287-1.06 1.472-1.06 1.472l-.01.026h15.642v-4.346c0-.8-.655-1.455-1.455-1.455H11.934v4.355zM8.64 14.528l-.009-.026s-1.178-.185-1.06-1.473c0 0 .116-.887 1.079-1.044 0 0 .501-.104 1.006.296l.805.8V8.728H4.689c-.8 0-1.454.655-1.454 1.455v4.346H8.64zM13.309 16l1.172 1.172v2.057l-2.547-2.535v5.107h16.01c.8 0 1.454-.655 1.454-1.455V16h-16.09zM10.462 16.694L7.916 19.23v-2.057L9.087 16H3.234v4.346c0 .8.654 1.455 1.454 1.455h5.774v-5.107z" fill="currentColor"/></svg>
            </div>
            <div class="leading-snug">
              <h3 class="pb-1 text-base font-lufthansa-head font-bold md:pb-2 xl:text-2xl text-4y-sky-blue">
                {{ tr('pages.sales.landing.benefit.three.title') }}
              </h3>
              <p class="text-sm leading-snug xl:text-base tracking-wide">
                {{ tr('pages.sales.landing.benefit.three.description') }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="mb-12 md:px-6 lg:px-8 xl:px-20 xl:mb-20 text-black">
      <div class="container">
        <h2 id="get-voucher" class="px-4 pb-4 text-xl font-bold md:pb-6 md:text-2xl md:px-0 xl:text-1.85xl font-lufthansa-head text-4y-sky-blue">
          {{ tr('pages.sales.landing.types.title') }}
        </h2>
        <div class="flex px-4 py-4 md:justify-start md:py-0 md:px-0 flex-col md:flex-row">
          <TypeCard
            :title="tr('pages.sales.landing.types.digital.title')"
            class="md:mr-6 xl:mr-14 mb-6 md:mb-0"
          >
            <template v-slot:image>
              <img
                srcset="~images/discover/offers/digital-voucher@2x.jpg 2x, ~images/discover/offers/digital-voucher.jpg 1x "
                src="~images/discover/offers/digital-voucher.jpg"
                alt="Discover Airlines customer "
              >
            </template>

            <p class="text-sm xl:text-base">
              {{ tr('pages.sales.landing.types.digital.benefit') }}
            </p>

            <template v-slot:buttons>
              <Button
                variant="primary"
                :href="$i18nTo({ name: 'voucherSaleAmount' })"
              >
                {{ tr('pages.sales.landing.types.digital.button') }}
              </Button>
            </template>
          </TypeCard>

          <TypeCard :title="tr('pages.sales.landing.types.existing.title')">
            <template v-slot:image>
              <img
                srcset="~images/discover/offers/digital-voucher-app@2x.jpg 2x, ~images/discover/offers/digital-voucher-app.jpg 1x"
                src="~images/discover/offers/digital-voucher-app.jpg"
                alt=""
              >
            </template>

            <p class="text-sm xl:text-base">
              {{ tr('pages.sales.landing.types.existing.description') }}
            </p>

            <template v-slot:buttons>
              <Button
                variant="secondary"
                href="https://discover-airlines.com"
              >
                {{ tr('pages.sales.landing.types.existing.button.redeem') }}
              </Button>
            </template>
          </TypeCard>
        </div>
      </div>
    </div>
    <div class="container mb-12 xl:mb-20">
      <HowItWorks />
    </div>
    <SellerNote />
  </div>
</template>

<script>
import Vue from 'vue'
import HowItWorks from '~brand-components/discover/sale-landing-page/how-it-works.vue'
import Button from '~brand-components/discover/button/button.vue'
import TypeCard from '~brand-components/discover/type-card/type-card.vue'
import SellerNote from '~brand-pages/discover/seller-note.vue'

export default Vue.extend({
  components: {
    SellerNote,
    Button,
    HowItWorks,
    TypeCard,
  },
})
</script>

<style lang="scss" scoped>
.hero {
  min-height: 490px;
  background: skyblue;
  background: linear-gradient(98.25deg, rgba(0, 37, 84, 0.4) 40.32%, rgba(0, 36, 82, 0.292) 64.1%, rgba(0, 0, 0, 0) 93.57%),
  url("../../images/discover/hero-sale/700.jpg") center top / cover no-repeat;

  @media (-webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi) {
    background-image: url("../../images/discover/hero-sale/700@2x.jpg") center top / cover no-repeat;
  }
}

@screen md {
  .hero {
    min-height: 530px;
    background: url("../../images/discover/hero-sale/1452.jpg") center center / cover no-repeat;

    @media (-webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi) {
      background-image: url("../../images/discover/hero-sale/1452@2x.jpg") center center / cover no-repeat;
    }
  }
}

@screen xl {
  .hero {
    background: url("../../images/discover/hero-sale/2560.jpg") center top / cover no-repeat;
    min-height: 631px;
    aspect-ratio: 2400 / 900;

    @media (-webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi) {
      background-image: url("../../images/discover/hero-sale/2560@2x.jpg");
    }
  }
}
</style>
